import { useContext } from 'react';
import UserCompanyContext from '../context/UserCompany.context';

const useUserCompany = () => useContext(UserCompanyContext);
export default useUserCompany;
